var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown-item',{attrs:{"disabled":_vm.isOnFreePlan},on:{"click":_vm.openModal}},[_vm._v(" "+_vm._s(_vm.$t('integrations.details.button.reconfigure'))+" "),(_vm.isSingleStep)?_c('SingleStepConfigurationModal'):_c('MultiStepConfigurationModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }